import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, palette, variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import { Text } from '../Text/Text.es.js';

const variantStyles = variant({
  prop: "variant",
  variants: {
    empty: {
      color: "neutral.400"
    },
    success: {
      color: "primary.500"
    },
    danger: {
      color: "danger.500"
    }
  }
});
const Icon = styled(Box)`
    font-size: 0;
    padding-bottom: ${spacing("sm")};
`;
const Content = styled(Text)`
    color: ${palette("neutral.400")};
`;
const UiState = styled(Box)`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: ${({ align }) => align};
    ${variantStyles};
`;

export { Content, Icon, UiState };
//# sourceMappingURL=styled.es.js.map
